export default __webpack_public_path__ + "static/footer-pink-bg-e1c21b5f62c5a5207ec3c16f8f8636c4.png";